import React from 'react';
import { Outlet } from 'react-router-dom';

const NationalPlusRouter: React.FC = () => {
  return <Outlet />;
};

export default NationalPlusRouter;
